import LocalizedString from './LocalizedString';
import OptionRequirement from './OptionRequirement';

export default class Option {
  public value: string;

  public name: LocalizedString;

  public requires?: OptionRequirement;

  public display: string;

  constructor(row: any) {
    this.value = row.id;
    this.name = new LocalizedString(row.text);
    if (row.display) {
      this.display = row.display;
    }
    if (row.requires) {
      const requirements = Object.entries(row.requires)[0];
      this.requires = new OptionRequirement(requirements[0], requirements[1] as any);
    }
  }
}
